import type { FC } from "react"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material"

import { useOrgUsersQuery } from "features/api"
import PageTitle from "widgets/common/PageTitle"
import { HeaderContainer } from "../styled/containers"
import CreateUserButton from "./CreateUserButton"
import UsersTable from "./UsersTable"

interface OrgUsersProps {
  orgId: number | null
}

const OrgUsers: FC<OrgUsersProps> = ({ orgId }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { currentData: usersRoles, isLoading: usersLoading } = useOrgUsersQuery(
    {
      orgId: orgId as number,
    },
    { skip: !orgId },
  )
  // A page change brings the title back into view, and the create button beside it.
  const headerRef = useRef<HTMLDivElement>(null)

  return (
    <>
      <HeaderContainer ref={headerRef}>
        <PageTitle text={t("generic.USERS")} />
        <CreateUserButton />
      </HeaderContainer>
      <UsersTable
        users={usersRoles?.roles}
        isLoading={usersLoading}
        sx={{ border: `1px solid ${theme.palette.neutral[400]}` }}
        scrollAnchorRef={headerRef}
      />
    </>
  )
}

export default OrgUsers
